import { _initialState } from './_initialState';
import {
  updateDisabled,
  updateChoicesInfo,
  updateViolatingSegments,
  updateCompatibilitySegments,
  updateCompatibilityHeights,
  updateEnabledSizes,
  getCompatibilitySegmentGroups,
  getCompatibilitySegmentGroupsBySize,
  getCompatibilitySegmentGroupsByProductType
} from './actions';

export const compatibilityStore = (set, get) => ({
  ..._initialState,
  updateDisabled: (ids) => updateDisabled(set, get, ids),
  updateChoicesInfo: (choices) => updateChoicesInfo(set, get, choices),
  updateViolatingSegments: (violatingSegments) => updateViolatingSegments(set, get, violatingSegments),
  updateCompatibilitySegments: (segments) => updateCompatibilitySegments(set, get, segments),
  updateCompatibilityHeights: (segmentHeights) => updateCompatibilityHeights(set, get, segmentHeights),
  updateEnabledSizes: (sizes) => updateEnabledSizes(set, get, sizes),
  getCompatibilitySegmentGroupsBySize: (size) => getCompatibilitySegmentGroupsBySize(get, size),
  getCompatibilitySegmentGroups: () => getCompatibilitySegmentGroups(get),
  getCompatibilitySegmentGroupsByProductType:
  (productType) => getCompatibilitySegmentGroupsByProductType(get, productType)
});
